import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

const handle = (error, fallback) => {
    if (error.response?.data) throw error.response.data;
    throw error.message || fallback;
};

// 1. Queue of pending indent amendments (role/CC scoped server-side)
export const getVerifyIndentAmendQueue = async (roleId, username) => {
    try {
        const res = await axios.get(`${base}/Purchase/GetVerifyIndentAmend`, { params: { Roleid: roleId, Username: username } });
        return res.data;
    } catch (error) { return handle(error, 'Failed to fetch indent amendment queue'); }
};

// 2. Amendment header + item list for one amend
export const getIndentAmendByNo = async (cccode, amendId, indentNo) => {
    try {
        const res = await axios.get(`${base}/Purchase/GetIndentAmendbyNo`, { params: { CCCode: cccode, AmendId: amendId, IndentNo: indentNo } });
        return res.data;
    } catch (error) { return handle(error, 'Failed to fetch amendment details'); }
};

// 3. Verify/Approve/Reject/Return
export const approveIndentAmend = async (payload) => {
    try {
        const res = await axios.put(`${base}/Purchase/ApproveIndentAmend`, payload);
        return res.data;
    } catch (error) { return handle(error, 'Failed to submit verification'); }
};
